import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const Train = t0 => {
  const $ = _c(6);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <g clipPath="url(#train)"><path d="M12.68 11.52v.051l.009.05c.004.023.006.061.001.102a.228.228 0 0 1-.023.082.04.04 0 0 1-.018.018.361.361 0 0 1-.169.028H3.52a.361.361 0 0 1-.168-.028.04.04 0 0 1-.019-.018.225.225 0 0 1-.023-.082.372.372 0 0 1 .001-.101l.01-.05V1.602c.115-.026.249-.054.399-.084.444-.09 1.011-.195 1.592-.295.581-.1 1.172-.195 1.666-.265C7.488.887 7.85.85 8 .85c.109 0 .384.03.806.091.405.059.903.141 1.43.233.843.148 1.75.318 2.444.456v9.891ZM3.2 3.84h9.6m0 3.2H3.2M8 3.96v3.2" /><circle cx="5.76" cy="9.46" r=".96" /><circle cx="10.24" cy="9.46" r=".96" /><path d="M8.32 15.36h-6.4l2.684-3.2H4.48" /><path d="M7.68 15.36h6.4l-2.684-3.2h.124" /><path strokeLinecap="round" d="M3.84 13.44h8.32" /></g>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <defs><clipPath id="train"><path d="M0 0h16v16H0z" /></clipPath></defs>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props) {
    t3 = <IconWrapper {...props} variant="outline" viewBox="0 0 16 16" strokeWidth={0.9}>{t1}{t2}</IconWrapper>;
    $[4] = props;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export { Train };